import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { TranslocoModule } from '@jsverse/transloco';

import { UiIconsModule } from 'ui-icons';

import { MessageComponent } from './message.component';

import { UiPlatformButtonComponent } from '../button/button.component';

@NgModule({
  declarations: [MessageComponent],
  imports: [
    CommonModule,
    TranslocoModule,
    UiIconsModule,
    UiPlatformButtonComponent
  ],
  exports: [MessageComponent]
})
export class UiPlatformMessageModule {}
